<jw-modal id="calendarInfoModal">
  @if (this.defect.data !== undefined) {
    <div class="row">
      <div class="col">
        <h1 class='header'>{{defect.data.vehicle.registration}} - {{defect.data.description}}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <ul>
          @if (defect.data.vehicleInspectionIntervalsId === -1) {
            <li>Standard Defect</li>
          }
          @if (defect.data.vehicleInspectionIntervalsId > 0) {
            <li>{{defect.data.inspectionInterval.name}}</li>
          }
          @if (defect.data.bookedFor !== null) {
            <li>Booked For: {{defect.data.bookedFor}}</li>
          }
          <li>{{defect.data.vehicleCheckArea.name}} - {{defect.data.vehicleSeverity.notes}}</li>
        </ul>
      </div>
    </div>
  }

  <div class="row">
    <div class="col btn-group">
      @if (this.defect.data !== undefined) {
        <button class='btn btn-info' (click)='this.viewPage()'>View Defect</button>
      }
      <button class='btn btn-primary' (click)='this.close()'>Close</button> &nbsp;&nbsp;
    </div>
  </div>

</jw-modal>
